import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { LicenseInfo } from "@mui/x-license";
import "./index.css";
import App from "./App.jsx";

// Initialize Sentry for error tracking
const sentryEnabled = import.meta.env.VITE_SENTRY_ENABLED === "true";
if (sentryEnabled) {
  import("@sentry/react").then(({ init, browserTracingIntegration, replayIntegration }) => {
    init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "development",
      integrations: [
        browserTracingIntegration(),
        replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      tracesSampleRate: 0.1, // Adjust based on your needs
      replaysSessionSampleRate: 0.1, // Adjust based on your needs
      replaysOnErrorSampleRate: 1.0,
    });
    console.log("Sentry initialized for error tracking");
  });
} else {
  console.log("Sentry disabled (VITE_SENTRY_ENABLED not set to true)");
}


/*
License key security

The license key is checked without making any network requests—it's designed to be public. 
It's expected that the license key will be exposed in a JavaScript bundle; we simply ask licensed users not to actively publicize their license key.

https://mui.com/x/introduction/licensing/#license-key-security
*/

// in theory it would be better to store this as an env variable, but we are literally going to load it into the front end anyhow
LicenseInfo.setLicenseKey('8e8b77baa045be2cff9871d0058a4990Tz0xMDY4NDEsRT0xNzY5NzMxMTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y');

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
